import DownloadViewer from '../../content_viewer/viewers/download_viewer.vue';
import { diffModes } from '../constants';
export default {
    name: 'DownloadDiffViewer',
    components: {
        DownloadViewer
    },
    props: {
        diffMode: {
            type: String,
            required: true
        },
        newPath: {
            type: String,
            required: true
        },
        oldPath: {
            type: String,
            required: true
        },
        projectPath: {
            type: String,
            required: false,
            default: ''
        }
    },
    diffModes
};
